import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cellEditFactory from "react-bootstrap-table2-editor";
import { mahdoodeColumn } from "Constants/TableColumns";
import { read } from "Helpers/LocalStorage";
import { getMahdoode, UpdatePriceMahdoode } from "Stores/actions";
import { Grid } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function MahdoodeYaraghTable() {
  const { t } = useTranslation();
  const {
    mahdoodeData,
    selectedBazsho,
    isWidth,
    isHeight,
    mahdoodeDataPagination,
    mahdoodeDataSearch,
    selectedBrandYaragh,
    rtlLayout
  } = useSelector((state) => ({
    mahdoodeData: state.yaragh.mahdoodeData,
    mahdoodeDataPagination: state.yaragh.mahdoodeDataPagination,
    selectedBazsho: state.yaragh.selectedBazsho,
    isWidth: state.yaragh.isWidth,
    isHeight: state.yaragh.isHeight,
    mahdoodeDataSearch: state.yaragh.mahdoodeDataSearch,
    rtlLayout: state.settings.rtlLayout,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));

  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tblData, setTblData] = useState(mahdoodeData);
  const [columns, setColumns] = useState();
  const [search, setSearch] = useState("");
  const [param, setParam] = useState({})

  useEffect(() => {
    if (selectedBazsho) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = selectedBazsho?.IsG;
      const isUserHasAccessPrice2 = read("yaraghRules").accessPrice2;
      const updateFittingsColumn = [...mahdoodeColumn];
      updateFittingsColumn[3].hidden = !isWidth;
      updateFittingsColumn[4].hidden = !isHeight;
      updateFittingsColumn[6].hidden =
        isAdmin ||
        (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) ;
      updateFittingsColumn[2].align = rtlLayout ? "right" : "left";
      updateFittingsColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateFittingsColumn);
    }
    return () => setColumns(null);
  }, [selectedBazsho, isWidth, isHeight]);

  useEffect(() => {
    if (mahdoodeData) {
      setTblData(mahdoodeData);
      setTotal(mahdoodeDataPagination.Total);
      setCurrentPage(mahdoodeDataPagination.Page);
      setSizePerPage(mahdoodeDataPagination.Limit);
    }
  }, [mahdoodeData, mahdoodeDataPagination]);

  useEffect(() => {
    (async () => {
      if(selectedBazsho)
        await onGetMahdoode(false, 1)
    })();
  }, [selectedBazsho]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      await onGetMahdoode(false, page, sizePerPage);
    }
  }

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    setCurrentPage(1);
    await onGetMahdoode(false, 1, sizePerPage, search);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    setCurrentPage(1);
    await onGetMahdoode(false, 1, sizePerPage, "");
  }

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdRange: row.Id,
          };
          await dispatch(UpdatePriceMahdoode(data));
          await onGetMahdoode(true);
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
  }

  const onGetMahdoode = async (Force = false, Page = currentPage, Limit = sizePerPage, data = 'NODATA') => {
    setLoading(true);
    try{
      let dataSearch = null;
      if(data !== 'NODATA') {if(data !== '') dataSearch = { Name: convertToEnglishNumber(data) }}
      else if(search !== '') dataSearch = { Name: convertToEnglishNumber(search) }
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdPop: selectedBazsho.Id,
        Limit,
        Page,
        ...dataSearch,
      };
      if(Force || JSON.stringify(params) !== JSON.stringify(param)) {
        // console.log('get', selectedDasteProfile, selectedTypeColor);
        setParam(params);
        await dispatch(getMahdoode(params));
      }
    } catch (err) { console.log('[onGetMahdoode]', err) }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container>
        <Grid item lg={4} md={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {selectedBazsho && selectedBrandYaragh && (
        <div className="yaragh-upper-selected-info">
          <p>{selectedBazsho.Name}</p>
          <p>{selectedBrandYaragh.Name}</p>
        </div>
      )}
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            autoSelectText: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_yaragh" />}
        />
      )}
    </Fragment>
  );
}

export default MahdoodeYaraghTable;
